import { applicationsClassification } from './applicationsClassification';
import { count } from './count';
import { groupApplicationsBySubcategory } from './groupApplicationsBySubcategory';
import { groupDaily } from './groupDaily';
import { groupWeekly } from './groupWeekly';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- generic type
export const transformers: Record<string, (data: any) => any> = {
    applicationsClassification,
    count,
    groupApplicationsBySubcategory,
    groupDaily,
    groupWeekly
};
